import {LocaleWithCatalogHookOptionsType, useLocalizedStringWithCatalogName} from './locale-with-catalog-name-hook';

export function LocaleWithCatalogName(props: LocaleWithCatalogHookOptionsType): JSX.Element {
    const result = useLocalizedStringWithCatalogName(props);

    return <span>{result}</span>;
}
